import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719cc9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msg_center_wrap" }
const _hoisted_2 = { class: "msg_center_menu" }
const _hoisted_3 = { class: "msg_center_item" }
const _hoisted_4 = { class: "msg_center_tbody" }
const _hoisted_5 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_6 = { class: "mod_c" }
const _hoisted_7 = { class: "mod_c_title" }
const _hoisted_8 = { class: "mod_c_tbody" }

import { computed, ref, shallowRef } from 'vue';
import { useStore } from 'vuex';
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { Menu } from 'ant-design-vue';
import { MenuType } from './types';
import Crumb from '@/components/Crumb.vue';
import http from '@/api/home';
import CustomSet from './CustomSet.vue';
import CustomWechat from './CustomWechat.vue';
import FollowOfficialAccount from './FollowOfficialAccount.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomServe',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useStore();
const aMenu = Menu;
const aMenuItem = Menu.Item;

// 根据header项过滤菜单
const selectedKeys = ref<string[]>([]);

const menuList = shallowRef<MenuType[]>([]);
const baseMenu: Array<MenuType> = [
  {
    name: 'CustomMade',
    title: '定制配置',
    path: '/personal/custom/set',
    component: CustomSet,
  },
  {
    name: 'CustomWechat',
    title: '微信定制',
    path: '/personal/custom/wchat',
    component: CustomWechat,
  },
  {
    name: 'FollowOfficialAccount',
    title: '关注公众号',
    path: '/personal/custom/FollowOfficialAccount',
    component: FollowOfficialAccount,
  },
];
const urlPush = (e: any) => {
  router.push(e.key);
};
const getMenu = async () => {
  if (store.state.home.billMenu.length === 0) {
    const res = await http.getFuncPermission({
      params: {
        item_ids: {
          CustomMade: 654,
          CustomWechat: 570,
          FollowOfficialAccount: 1255,
        },
      },
    });
    const resData = res.data.data;
    menuList.value = baseMenu.filter((e) => resData[e.name]);
    if (!route.params.name) {
      selectedKeys.value = [menuList.value[0].path];
    } else {
      const keyId = menuList.value.findIndex((e) => e.path === route.path);
      if (keyId === -1) {
        router.push('/404');
      } else {
        selectedKeys.value = [route.path];
      }
    }
  }
};
const activedKey = computed(() => menuList.value.findIndex((e) => e.path === selectedKeys.value[0]));
const viewTitle = computed(() => (selectedKeys.value.length > 0 ? menuList.value[activedKey.value].title : route.meta?.title));
/**
 * init 初始化
 * 路由进入前处理底部栏
 * */
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
getMenu();

onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(route).meta?.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item) => {
        return (_openBlock(), _createBlock(_unref(aMenu), {
          key: item.path,
          selectedKeys: selectedKeys.value,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
          "inline-indent": 18,
          class: "msg_center_menu_main",
          theme: "light",
          mode: "inline",
          onClick: urlPush
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_unref(aMenuItem), {
              key: item.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024))
          ]),
          _: 2
        }, 1032, ["selectedKeys"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Crumb),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(viewTitle)), 1),
          _createElementVNode("div", _hoisted_8, [
            (selectedKeys.value.length > 0)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(menuList)[_unref(activedKey)].component), { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
        [_vShow, _unref(customFootStyle)]
      ])
    ])
  ]))
}
}

})